import { render } from "./ClientWidget.vue?vue&type=template&id=285343b4"
import script from "./ClientWidget.vue?vue&type=script&lang=js"
export * from "./ClientWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__